import React, { useContext, useState, useEffect } from 'react'
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {
  Grid,
  Stack,
  Button,
  TextField,
  Typography,
  IconButton,
  FormControl,
  Select,
  MenuItem, InputAdornment, FormHelperText
} from "@mui/material";
import "../../../Style/dialogstyle.scss";
import { BiMinusCircle } from "react-icons/bi";
import { useMutation } from "@apollo/client";
//date picker
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import { AuthContext } from "../../../Context/AuthContext";
import { SelectSupplier } from "../../Include/DynamicSelect"
import { SelectWarehouse } from "../../Include/DynamicSelect"
import ListPurchase from './ListPurchase';
import { UPDATE_ADJUST_IN } from "../../../Schema/Ajustment";


export default function UpdateAjustIn({ open, handleClose, setRefetch, editData }) {

  const { setAlert } = useContext(AuthContext)
  const [loading, setLoading] = useState(false)

  const [selectSupplier, setSelectedSupplier] = useState({ id: "", title: "" })
  const [selectWarehouse, setSelectedWarehouse] = useState({ id: "", title: "" })
  const [requireField, setRequireField] = useState(false);

  const listAdjInMaterial = {
    materialId: { id: "", title: "" },
    listMaterialUnitId: { id: "", title: "" },
    unitPrice: 0,
    checkUnitPrice: 200,
    // desc: "",
    qty: 0,
    image: "",
    key: Date.now() + Math.random(),
  }

  const [listData, setListData] = useState([listAdjInMaterial]);

  //updateAdjustIn
  const [updateAdjustIn] = useMutation(UPDATE_ADJUST_IN, {
    onCompleted: ({ updateAdjustIn }) => {
      // console.log("updateAdjustIn::", updateAdjustIn)
      setLoading(false);
      if (updateAdjustIn?.status) {
        setAlert(true, "success", updateAdjustIn?.message);
        handleClose();
        resetForm();
        setRefetch();
        setSelectedSupplier({ id: "", title: "" })
        setSelectedWarehouse({ id: "", title: "" })
        setListData([listAdjInMaterial])
      } else {
        setAlert(true, "error", updateAdjustIn?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message)
      console.log("error::", error)
    }
  })
  //formik
  const CheckValidation = Yup.object().shape({
    dateTime: Yup.date().required("ទាមទារ!"),
    remark: Yup.string(),
    warehouseId: Yup.string().required("ទាមទារ!"),
    supplierId: Yup.string().required("ទាមទារ!"),
    reason: Yup.string().required("ទាមទារ!"),
  })

  const formik = useFormik({
    initialValues: {
      dateTime: new Date(),
      remark: "",
      warehouseId: "",
      supplierId: "",
      reason: "",
    },
    validationSchema: CheckValidation,
    onSubmit: async (values) => {

      console.log("listData:::", listData);
      // === Check Require =======
      let createStatus = false;
      const BreakException = {};
      try {
        if (listData?.length !== 0) {
          listData?.forEach(function (elem) {
            // console.log("element: ", elem)
            if (
              elem?.materialId?.id !== undefined &&
              elem?.materialId?.id !== "" &&
              elem?.listMaterialUnitId?.id !== undefined &&
              elem?.listMaterialUnitId?.id !== "" &&
              elem?.unitPrice > 0 &&
              elem?.qty > 0
            ) {
              createStatus = true;
            } else {
              setLoading(false);
              setRequireField(true);
              createStatus = false;
              throw BreakException;
            }
          });
        } else {
          setLoading(false);
          setRequireField(true);
        }
      } catch (e) {
        if (e !== BreakException) throw e;
      }

      console.log("createStatus::", createStatus)

      // 
      if (createStatus) { 
        let listAdjInToSubmit = listData.map((d) => { 
          return {
            listMaterialUnitId: d?.listMaterialUnitId?.id,
            unitPrice: d?.unitPrice,
            qty: d?.qty,
            key: d?.key,
          }
        })
        console.log("listAdjInToSubmit", listAdjInToSubmit)

        setLoading(true);
        updateAdjustIn({
          variables: {
            id: editData?._id,
            input: { 
              dateTime: values?.dateTime,
              warehouseId: values?.warehouseId,
              supplierId: values?.supplierId,
              listAdjInMaterial: listAdjInToSubmit,
              remark: values.remark,
              reason: values?.reason,
            }
          }
        })

      }
    }
  })



  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    values,
    resetForm,
  } = formik;
 

  useEffect(() => {
    setFieldValue("supplierId", selectSupplier?.id ? selectSupplier?.id : "")
    setFieldValue("warehouseId", selectWarehouse?.id ? selectWarehouse?.id : "")
  }, [selectSupplier?.id, selectWarehouse?.id])


  useEffect( () => {
    if(editData) {
      // console.log("editData::::", editData);
      setSelectedSupplier({ id: editData?.supplierId?._id , title: editData?.supplierId?.name});
      setSelectedWarehouse({ id: editData?.warehouseId?._id , title: editData?.warehouseId?.warehouseName });

      setFieldValue("dateTime", editData?.dateTime || null);
      setFieldValue("supplierId", editData?.supplierId?._id);
      setFieldValue("warehouseId", editData?.warehouseId?._id);
      setFieldValue("remark", editData?.remark);
      setFieldValue("reason", editData?.reason || ""); 

      if(editData?.listAdjInMaterial) {
        let rowList = [];
        editData?.listAdjInMaterial?.map( (row,index) => {
          const allRow = {
            materialId: { 
              id: row?.listMaterialUnitId?.materialId?._id , 
              title: row?.listMaterialUnitId?.materialId?.materialKhName,
            },
            listMaterialUnitId: { 
              id: row?.listMaterialUnitId?._id, 
              title: row?.listMaterialUnitId?.unitId?.unitKhName,
            },
            unitPrice: row?.unitPrice,
            checkUnitPrice: 200,
            // desc: "",
            qty: row?.qty,
            image: row?.listMaterialUnitId?.imageSrc,
            key: index+Date.now() + Math.random(),
          }
          // 
          rowList.push(allRow)
        })

        setListData(rowList)
      }

    }  
  },[open]) 


  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="lg">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px" }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography className='dialog-title'>បង្កើតការផ្ទេរចូល</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton onClick={handleClose}>
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete='off' onSubmit={handleSubmit} >
            <Grid container columnSpacing={3} rowSpacing={2}>
              
              <Grid item xs={3}>
                <Typography className='field-title'>អ្នកផ្គត់ផ្គង់</Typography>
                <SelectSupplier
                  selectedVal={selectSupplier}
                  setSelectedVal={setSelectedSupplier}
                  disabled={true}
                />
                {!!errors.supplierId && touched.supplierId && (
                  <FormHelperText errorid="outlined-adornment-password">
                    {errors.supplierId}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={3}>
                <Typography className='field-title'>ឃ្លាំងទំនិញ</Typography>
                <SelectWarehouse
                  selectedVal={selectWarehouse}
                  setSelectedVal={setSelectedWarehouse}
                  disabled={true}
                />
                {!!errors.warehouseId && touched.warehouseId && (
                  <FormHelperText errorid="outlined-adornment-password">
                    {errors.warehouseId}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={3}>
                <Typography className='field-title'>កាលបរិច្ឆេទចូលស្តុក</Typography>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    format="dd-MM-yyyy"  
                    value={values.dateTime ? new Date(values.dateTime) : null}
                    onChange={(newValue) => {
                      setFieldValue( "dateTime" , newValue);
                    }}
                    slotProps={{
                      textField: {
                        size: "small",
                        fullWidth: true,
                      },
                    }}
                    className="search-field"
                    renderInput={(params) => (
                      <TextField {...params} size="small" fullWidth />
                    )}
                  />
                </LocalizationProvider>
                
                {!!errors.dateTime && touched.dateTime && (
                  <FormHelperText errorid="outlined-adornment-password">
                    {errors.dateTime}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={3}>
                <Typography className='field-title'>មូលហេតុ</Typography>
                <FormControl className="search-field" fullWidth size="small">
                  <Select
                    value={values?.reason}
                    onChange={(e) => setFieldValue("reason", e.target.value)}
                  >
                    <MenuItem value="free">ឥតគិតថ្លៃ</MenuItem>
                    <MenuItem value="from_use">ពីការប្រើប្រាស់</MenuItem>
                    <MenuItem value="production">ផលិត</MenuItem>
                    <MenuItem value="lack">រាប់ខ្វះ</MenuItem>
                  </Select> 
                </FormControl>
                
                {!!errors.reason && touched.reason && (
                  <FormHelperText errorid="outlined-adornment-password">
                    {errors.reason}
                  </FormHelperText>
                )}
              </Grid> 





              <Grid item xs={12}>
                <Typography className='dialog-title-view'>
                  សម្ភារៈ
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <ListPurchase
                  listData={listData}
                  setListData={setListData}
                  requireField={requireField}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography className='field-title'>ចំណាំ</Typography>
                <TextField
                  className='text-field'
                  fullWidth
                  multiline
                  size='small'
                  placeholder='ចំណាំ'
                  {...getFieldProps("remark")}
                />
              </Grid>
            </Grid>

            <Grid item xs={12}>
              {loading ? (
                <Button className="btn-create" fullWidth>
                  កំពុងដំណើរការ...
                </Button>
              ) : (
                <Button
                  className="btn-create"
                  fullWidth
                  onClick={handleSubmit}
                >
                  កែប្រែ
                </Button>
              )}
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  )
}
